module.exports = __webpack_public_path__ + "static/img/home_bt3.d469ac20.png";